import React from "react";
import "./Login.scss"
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {isAuth} from "../../auth";
import {envLoader} from "../../../env/envLoader";
import { useState, useEffect } from 'react';

const baseUrl = envLoader().base_url;

let Login = (props) => {
  const { user } = props;

  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    setCheckingAuth(false);
  }, []);

  useEffect(() => {
    if (!checkingAuth && !isAuth(user)) {
      window.location.href = `${baseUrl}oauth2/authorization/kifl`;
    }
  }, [checkingAuth, user]);

  if (isAuth(user)) {
    return <Redirect to="/" />;
  }

  if (checkingAuth) {
    return null;
  }

  return <p className='authenticated'>Comprobando autenticacion...</p>

}


const mapPropsToState = state => {
    return {error: state.login.error, user: state.user}
}

Login = connect(mapPropsToState,null)(Login);
export default Login;
